import type { HTMLProps, PropsWithChildren, ReactElement } from 'react'
import { useEffect, useRef, useState } from 'react'

export enum SlideFromType {
  Top = 1,
  Right = 2,
  Bottom = 3,
  Left = 4,
}

export interface SlideProps extends PropsWithChildren<HTMLProps<HTMLDivElement>> {
  from: SlideFromType
  duration: number
  when: boolean
}

export function Slide({ from, duration, when, children, ...divProps }: SlideProps): ReactElement {
  const slideRef = useRef<HTMLDivElement>(null)
  const [transform, setTransform] = useState('none')

  function getXTransform(): string {
    if (!slideRef.current) {
      return 'none'
    }
    const offset = from === SlideFromType.Left ? '-' : ''
    return `translateX(${offset}100vw)`
  }

  function getYTransform(): string {
    if (!slideRef.current) {
      return 'none'
    }
    const offset = from === SlideFromType.Top ? '-' : ''
    return `translateY(${offset}100vh)`
  }

  useEffect(() => {
    if (slideRef.current) {
      setTransform(
        when
          ? 'none'
          : from === SlideFromType.Top || from === SlideFromType.Bottom
            ? getYTransform()
            : getXTransform(),
      )
    }
  }, [when, from])

  return (
    <div
      ref={slideRef}
      style={{
        transition: `transform ${duration}ms`,
        transform,
      }}
      aria-hidden={!when}
      {...divProps}
    >
      {children}
    </div>
  )
}
